module.exports = __webpack_public_path__ + "img/m_info.193dfb03.png";